import { render, staticRenderFns } from "./oncoPheno.vue?vue&type=template&id=adf957c0&"
import script from "./oncoPheno.vue?vue&type=script&lang=js&"
export * from "./oncoPheno.vue?vue&type=script&lang=js&"
import style0 from "./oncoPheno.vue?vue&type=style&index=0&id=adf957c0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports